import React from 'react';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';
import '../styles/PolicyPages.css';

const PrivacyPolicy = () => {
    return (
        <div className="policy-page-wrapper">
            <Navbar />
            <main className="policy-simple-container">
                <div className="policy-simple-header">
                    <h1>Privacy Policy – Prints Carts</h1>
                    <p className="last-updated">Last Updated: January 26, 2026</p>
                </div>

                <div className="policy-simple-content">
                    <div className="intro">
                        Prints Carts (“we,” “our,” or “us”) is committed to protecting your privacy and handling your personal information responsibly. This Privacy Policy explains how we collect, use, store, and protect your information when you visit our website or make a purchase from www.printscarts.com.<br /><br />
                        By using our website, you agree to the terms outlined in this Privacy Policy.
                    </div>

                    <section>
                        <h2>1. Company Information</h2>
                        <p>
                        Prints Carts<br />
                        7181 Beacon Dr 15<br />
                        Reno, NV 89506<br />
                        United States<br />
                        Email: support@printscarts.com<br />
                        Website: www.printscarts.com
                        </p>
                        <p>We operate as an independent online retailer offering printers, ink, toner, and printing supplies. All brand names and trademarks belong to their respective owners and are used only for identification.</p>
                    </section>

                    <section>
                        <h2>2. Information We Collect</h2>
                        <p>We collect only the information necessary to process orders, support customers, and operate our website.</p>
                        
                        <h3>A. Information You Provide Voluntarily</h3>
                        <p>This includes information you submit during checkout, account creation, or when contacting us:</p>
                        <ul>
                            <li>Name</li>
                            <li>Email address</li>
                            <li>Billing and shipping address</li>
                            <li>Phone number (optional)</li>
                            <li>Payment details (processed securely through third-party payment providers)</li>
                            <li>Order history</li>
                            <li>Messages or inquiries you send us</li>
                        </ul>

                        <h3>B. Automatically Collected Information</h3>
                        <p>When you browse our website, we collect limited technical data such as:</p>
                        <ul>
                            <li>IP address</li>
                            <li>Browser type</li>
                            <li>Device information</li>
                            <li>Pages viewed</li>
                            <li>Essential session data for cart functionality</li>
                            <li>Basic usage information required for site security</li>
                        </ul>
                        <p>We do not use third-party tracking tools for behavioral advertising.</p>

                        <h3>C. Cookies & Essential Technologies</h3>
                        <p>We use cookies that are essential for:</p>
                        <ul>
                            <li>Secure checkout</li>
                            <li>Cart function</li>
                            <li>Website performance</li>
                            <li>Basic user preferences</li>
                        </ul>
                        <p>We do not use advertising cookies or third-party tracking pixels. For more details, see our Cookie Policy.</p>
                    </section>

                    <section>
                        <h2>3. How We Use Your Information</h2>
                        <p>We process your information only for legitimate business purposes:</p>
                        
                        <div className="sub-section">
                            <h4>Order Processing & Fulfillment</h4>
                            <ul>
                                <li>To manage orders, payments, shipping, and delivery</li>
                                <li>To send order confirmation and updates</li>
                                <li>To verify product availability</li>
                            </ul>
                        </div>

                        <div className="sub-section">
                            <h4>Customer Support</h4>
                            <ul>
                                <li>To respond to product inquiries</li>
                                <li>To assist with returns, refunds, and order status</li>
                                <li>To provide general support</li>
                            </ul>
                        </div>

                        <div className="sub-section">
                            <h4>Operational & Security Purposes</h4>
                            <ul>
                                <li>To improve website performance</li>
                                <li>To protect against fraud and unauthorized activity</li>
                                <li>To ensure secure checkout</li>
                            </ul>
                        </div>

                        <div className="sub-section">
                            <h4>Legal Requirements</h4>
                            <p>To comply with applicable laws, tax requirements, and fraud-prevention rules.</p>
                        </div>

                        <p>We do not sell or share your personal information for advertising purposes.</p>
                    </section>

                    <section>
                        <h2>4. Information Sharing</h2>
                        <p>We only share your information with trusted third parties necessary for essential operations:</p>
                        <p>We may share information with:</p>
                        <ul>
                            <li>Payment processors</li>
                            <li>Shipping carriers</li>
                            <li>Customer communication tools</li>
                            <li>Fraud-prevention services</li>
                            <li>IT and hosting providers</li>
                            <li>Legal authorities (when required by law)</li>
                        </ul>
                        <p>All partners are contractually obligated to handle your information securely.</p>
                        <p>We DO NOT:</p>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            <li>❌ Sell personal data</li>
                            <li>❌ Share data for advertising purposes</li>
                            <li>❌ Allow unauthorized access</li>
                        </ul>
                    </section>

                    <section>
                        <h2>5. Data Security</h2>
                        <p>We use industry-standard security measures to help protect your information, including:</p>
                        <ul>
                            <li>SSL/TLS encryption</li>
                            <li>Secure checkout</li>
                            <li>Access controls</li>
                            <li>Safe data-handling practices</li>
                            <li>Regular monitoring for suspicious activity</li>
                        </ul>
                        <p>No method of electronic transmission is 100% secure, but we take reasonable steps to safeguard your information.</p>
                    </section>

                    <section>
                        <h2>6. Your Privacy Rights</h2>
                        <p>Depending on your location, you may have the right to:</p>
                        <ul>
                            <li>Access Your Data: Request a copy of the personal information we hold.</li>
                            <li>Request Corrections: Update inaccurate or incomplete information.</li>
                            <li>Request Deletion: Ask to have your information deleted (subject to legal requirements).</li>
                            <li>Opt Out of Non-Essential Communications: Unsubscribe from non-essential emails anytime.</li>
                            <li>Data Portability: Receive your data in a structured format.</li>
                        </ul>

                        <h3>CCPA/CPRA Rights (California Residents)</h3>
                        <ul>
                            <li>Right to know what data is collected</li>
                            <li>Right to request deletion</li>
                            <li>Right to opt out of “sale” or “sharing” of personal information</li>
                            <li>Right to non-discrimination</li>
                        </ul>
                        <p>Prints Carts does not sell or share personal information under the CCPA/CPRA definitions.</p>
                        <p>How to Exercise These Rights: Email us at support@printscarts.com. We may request identity verification for your safety.</p>
                    </section>

                    <section>
                        <h2>7. Data Retention</h2>
                        <p>We retain your information only as long as necessary to:</p>
                        <ul>
                            <li>Fulfill orders</li>
                            <li>Meet legal and tax obligations</li>
                            <li>Maintain business records</li>
                            <li>Prevent fraud</li>
                            <li>Resolve disputes</li>
                        </ul>
                        <p>When no longer needed, data is securely deleted or anonymized.</p>
                    </section>

                    <section>
                        <h2>8. Third-Party Links</h2>
                        <p>Our website may include links to external websites for additional information. Prints Carts is not responsible for the privacy practices or content of third-party websites. We recommend reviewing their policies before submitting any information.</p>
                    </section>

                    <section>
                        <h2>9. Children’s Privacy</h2>
                        <p>Our services are not intended for children under 13. We do not knowingly collect personal information from children. If we learn that we have unintentionally collected such data, we will delete it promptly.</p>
                    </section>

                    <section>
                        <h2>10. Changes to This Privacy Policy</h2>
                        <p>We may update this Privacy Policy to reflect changes in our practices or legal requirements. Updates will be posted on this page with a revised “Last Updated” date. Continued use of our website means you accept the updated terms.</p>
                    </section>

                    <section>
                        <h2>11. Contact Us About Privacy</h2>
                        <p>If you have questions, concerns, or requests related to your personal information, please contact us:</p>
                        <p>
                            Email: support@printscarts.com<br />
                            Address: 7181 Beacon Dr 15, Reno, NV 89506<br />
                            Website: www.printscarts.com
                        </p>
                    </section>
                </div>
                
                <div className="policy-document-footer">
                    <span style={{ fontSize: '13px', color: '#94a3b8' }}>Document Reference: PC-PP-2026-V1</span>
                    <button 
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        style={{ background: 'none', border: 'none', color: '#0f3d91', fontWeight: '600', cursor: 'pointer' }}
                    >
                        Back to Top ↑
                    </button>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
